/* Two additions that sit on top of cheeky-dad.js without touching it:
   1) keep the thumbnail rail scrolled to whatever the big gallery is showing;
   2) a NEW badge on the freshly launched styles.
   The badge sits INSIDE the tile (top:2px/left:2px, not negative offsets) — the
   rail clips overflow, so anything hanging outside the button gets cut off. */
(function(){
var NEW_NAMES=['The Canada Leopard','The Canada Gold'];

function isNew(t){for(var i=0;i<NEW_NAMES.length;i++){if(t===NEW_NAMES[i])return true;}return false;}

function badge(){
var b=document.createElement('span');
b.setAttribute('data-cd-new','1');
b.textContent='NEW';
b.setAttribute('style','position:absolute; top:2px; left:2px; z-index:4; background:#b1272f; color:#fff; font-family:Inter,sans-serif; font-size:7px; font-weight:800; letter-spacing:0.3px; padding:1.5px 3.5px; border-radius:4px; line-height:1.1; pointer-events:none;');
return b;
}

function markBadges(){
var roots=[document.getElementById('cd-thumbs'),document.getElementById('cd-pairs')];
roots.forEach(function(root){
if(!root)return;
var btns=root.querySelectorAll('button[title]');
for(var i=0;i<btns.length;i++){
var b=btns[i];
if(!isNew(b.getAttribute('title')))continue;
if(b.querySelector('[data-cd-new]'))continue;
b.style.position='relative';
b.style.overflow='hidden';
b.appendChild(badge());
}
});
}

function syncRail(){
var gal=document.getElementById('cd-gallery');
var rail=document.getElementById('cd-thumbs');
if(!gal||!rail||!gal.clientWidth)return;
var i=Math.round(gal.scrollLeft/gal.clientWidth);
var btns=rail.querySelectorAll('button');
if(!btns[i])return;
var t=btns[i];
var target=t.offsetLeft-(rail.clientWidth/2)+(t.offsetWidth/2);
target=Math.max(0,Math.min(target,rail.scrollWidth-rail.clientWidth));
if(Math.abs(rail.scrollLeft-target)>6){
try{rail.scrollTo({left:target,behavior:'smooth'});}catch(e){rail.scrollLeft=target;}
}
}

var bound=false;
function bind(){
var gal=document.getElementById('cd-gallery');
if(gal&&!bound){
bound=true;
var t=null;
gal.addEventListener('scroll',function(){clearTimeout(t);t=setTimeout(syncRail,140);},{passive:true});
}
markBadges();
syncRail();
}

if(window.MutationObserver){
new MutationObserver(function(){markBadges();}).observe(document.documentElement,{subtree:true,childList:true});
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',bind);}else{bind();}
setTimeout(bind,300);
setTimeout(bind,900);
setTimeout(bind,1800);
})();
